export const MOBILE_MENU_FADE_TRANSITION_LENGTH = 150
export const MOBILE_MENU_SLIDE_IN_TRANSITION_LENGTH = 150
export const MOBILE_MENU_SLIDE_OUT_TRANSITION_LENGTH = 100
export const MOBILE_MENU_EXIT_TRANSITION_LENGTH =
  MOBILE_MENU_FADE_TRANSITION_LENGTH + MOBILE_MENU_SLIDE_OUT_TRANSITION_LENGTH
